import React from 'react';

import { useTranslation } from 'react-i18next';
import type { OptionalArrayField, ReferenceField } from '@uncinc/react-drupal-core/types';

import Tags from '../../Tags';
import { taxonomyTagElasticMapper, taxonomyTagEntityMapper } from '../../Tags/taxonomyTagMapper';
import type { TaxonomyTheme } from '../../../types/uncinc_profile/taxonomy';

interface ThemesTaxonomyProps {
  themes?: OptionalArrayField<[ReferenceField<TaxonomyTheme>]>;
  themesNames?: never;
  tagsOverflow?: boolean;
}

interface ThemesNamesProps {
  themes?: never;
  themesNames?: string[];
  tagsOverflow?: boolean;
}

const Themes: React.FC<ThemesTaxonomyProps | ThemesNamesProps> = (props) => {
  const { t } = useTranslation();
  const {
    themes,
    themesNames,
    tagsOverflow = true,
  } = props;

  return (
    <div className="ArticleMetadata__themes">
      {themes && (
        <div className="ArticleMetadata__themes__label">
          {t('taxonomies.themes.title', { count: themes.length })}
        </div>
      )}
      {themes && <Tags items={taxonomyTagEntityMapper(themes)} overflowStartIndex={tagsOverflow ? 1 : 0} />}
      {themesNames && <Tags items={taxonomyTagElasticMapper(themesNames, 'themes')} overflowStartIndex={1} />}
    </div>
  );
};

export default Themes;
